import { render, staticRenderFns } from "./ViewHistorico.vue?vue&type=template&id=3eea6d96&"
import script from "./ViewHistorico.vue?vue&type=script&lang=js&"
export * from "./ViewHistorico.vue?vue&type=script&lang=js&"
import style0 from "./ViewHistorico.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports